import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Product from "../../components/product/Product";
import productApi from "../../api/product/productApi";

const ProductEdit = (props) => {
  let { id } = useParams();
  const [product, setProduct] = useState();

  useEffect(() => {
    getProduct(id);
  }, []);

  const getProduct = (id) => {
    productApi.getProduct(id).then((res) => {
      if (res) {
        setProduct(res);
      }
    });
  };
  return <>{product ? <Product productItem={product} edit={true} id={id} /> : null}</>;
};

export default ProductEdit;
